export default __webpack_public_path__ + "static/media/europe.c3afe450.png";